export default "__VITE_ASSET__aa2701d6__"